/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { App } from 'vue';
import globals from './utils/globals';
export default {
	install(app: App<Element>): void {
		app.config.errorHandler = (error): void => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			if(globals.rollbar){
				globals.rollbar?.error(error);
			}	
		};
	},
};